import React, {useEffect} from 'react';
import { faBoxesStacked, faMapLocationDot, faChartPie,faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import issbyover from '../assets/issby-over.png';
import issbyunder from '../assets/issby-under.png';
import issbyright from '../assets/issby-just-right.png';
import './Matched.css'

function Matched() {
    useEffect(() => {
    // This runs whenever the entire application changes pages
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container">
      {/* Main Heading Area */}
      <header>
        <h1>Matched Retailers</h1>
        <p>
        A digital match has occurred within the ISSBY system. Contact information such as phone number is sent to both the retailers to contact and work out the details. This helps to buy and sell the over and under stock along with other operations. 
</p>
<p>ISSBY only matches the retailers to their overstocked or understocked counterpart. We don't provide the means to exchange the merchandise or facilitate transactions between two retailers. Such details could be arranged independent of ISSBY. </p>
      </header>
      {/*
      <hr style={{width: '40em'}}></hr>
      <div style={{display: 'flex', justifyContent: 'center', gap: '20em'}}>
  <table style={{ borderCollapse: 'collapse', marginTop: '2em' }} className='responsive-table'>
    <thead>
      <tr>
        <th scope="col" style={{  padding: '8px', textAlign: 'center', color: 'black' }}>OVERSTOCKED RETAILER</th>
        <th scope="col"style={{  padding: '8px', textAlign: 'center', color: 'black' }}>UNDERSTOCKED RETAILER</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{  padding: '8px' }}>
            Name
        </td>
        <td style={{ padding: '8px' }}>
            Name
        </td>
        </tr>
        <tr>
        <td style={{  padding: '8px' }}>
            Phone #
        </td>
        <td style={{ padding: '8px' }}>
            Phone #
        </td>
        </tr>
        <tr>
        <td style={{  padding: '8px' }}>
            Brand Name
        </td>
        <td style={{ padding: '8px' }}>
            Brand Name
        </td>
        </tr>
        <tr>
        <td style={{  padding: '8px' }}>
            Style Name
        </td>
        <td style={{ padding: '8px' }}>
            Style Name
        </td>
        </tr>
        <tr>
        <td style={{  padding: '8px' }}>
            SKU#
        </td>
        <td style={{ padding: '8px' }}>
            SKU#
        </td>
        </tr>
        <tr>
        <td style={{  padding: '8px' }}>
            Color
        </td>
        <td style={{ padding: '8px' }}>
            Color
        </td>
        </tr>
        <tr>
        <td style={{  padding: '8px' }}>
            Gender
        </td>
        <td style={{ padding: '8px' }}>
            Gender
        </td>
        </tr>
        <tr>
        <td style={{  padding: '8px' }}>
            How Many Pairs ?
        </td>
        <td style={{ padding: '8px' }}>
            How Many Pairs ?
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  */}
      <section className="ai-section">
        <h2 className="ai-logo">AI✨</h2>
      <p>
        Soon, based upon the summary data and how it changes over time, ISSBY will provide the retailers with that information. Thus, ISSBY helps retailers alleviate past mistakes, AND, avoid those that would be made in the future without ISSBY.
          </p>
      </section>
      <div style={{display: 'flex', justifyContent: 'center', gap: '20em'}}>
      <h2 style={{marginLeft: '2em'}} className="shimmer">HAPPY RETAILERS BUY MORE STUFF</h2>
      </div>
        <Link to="/summary" style={{ textDecoration: 'none', color: '#000', margin: '80%' }}>
        <button type="submit" style={{ padding: '10px 20px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
          Proceed to next page
        </button>
</Link>

    </div>
  );
}

export default Matched;
